import React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import * as S from './styles';

// type TooltipProps = React.ComponentProps<typeof TooltipPrimitive.Root> & {

// } // comentado por estar vazio, usar caso necessário

export function Tooltip ({ children, /* ...props */ }: /* TooltipProps */ React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipPrimitive.Provider delayDuration={200} skipDelayDuration={100}>
      <TooltipPrimitive.Root>
        {children}
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  )
}

// type TooltipContentProps = TooltipPrimitive.TooltipContentProps &
//   React.ComponentProps<typeof S.TooltipPrimitiveContent> & {
// } // comentado por estar vazio, usar caso necessário

export function TooltipContent ({ children, ...props }: /* TooltipContentProps */ TooltipPrimitive.TooltipContentProps & React.ComponentProps<typeof S.TooltipPrimitiveContent>) {
  return (
    <S.TooltipPrimitiveContent
      {...props}> {children}
    </S.TooltipPrimitiveContent>
  )
}

export const TooltipTrigger = TooltipPrimitive.Trigger;
TooltipTrigger.displayName = 'TooltipTrigger';

export const TooltipArrow = TooltipPrimitive.Arrow;
TooltipTrigger.displayName = 'TooltipArrow';
